import React from 'react';

/**
 * React.lazy with one automatic reload on a stale chunk (Pack C3, 2026-09-24).
 *
 * Admin, photographer and client-portal pages load as separate files now, so a
 * homepage visitor no longer downloads them. The catch: every Vercel deploy
 * renames those files. Someone with the site open across a deploy asks for a
 * file that no longer exists and gets a ChunkLoadError. The fix is to reload
 * once so they get the new build. A session flag stops a reload loop if the
 * failure is real (offline, blocked); then the error reaches the route's error
 * boundary as before.
 */
const FLAG = 'urp_chunk_reloaded';

export function isChunkLoadError(err) {
  const text = `${err && err.name} ${err && err.message}`;
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|dynamically imported module|Importing a module script failed/i.test(text);
}

export default function lazyWithRetry(factory) {
  return React.lazy(async () => {
    try {
      const mod = await factory();
      try { sessionStorage.removeItem(FLAG); } catch (e) { /* private mode */ }
      return mod;
    } catch (err) {
      let alreadyReloaded = false;
      try { alreadyReloaded = sessionStorage.getItem(FLAG) === '1'; } catch (e) { alreadyReloaded = true; }
      if (isChunkLoadError(err) && !alreadyReloaded) {
        try { sessionStorage.setItem(FLAG, '1'); } catch (e) { /* ignore */ }
        window.location.reload();
        return new Promise(() => {}); // never resolves; the page is reloading
      }
      throw err;
    }
  });
}
